import './ImportModalLayout.scss';
import classNames from 'classnames';
import { ReactElement, ReactNode } from 'react';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';

interface IImportModalLayout {
  isOpen: boolean;
  toggle: () => void;
  className?: string;
  headerText: ReactNode;
  buttons: ReactNode;
  children: ReactNode;
}

export const ImportModalLayout = ({ children, className, isOpen, headerText, buttons, toggle }: IImportModalLayout): ReactElement => (
  <S_Modal
    headerText={headerText}
    buttons={buttons}
    isOpen={isOpen}
    toggle={toggle}
    className={classNames('import-modal', className)}
  >
    {children}
  </S_Modal>
);
